/**
 * Attributes of FieldInstance that are keys of a DynamoDB global secondary index
 * (byFormInstance, byInstanceTableField, byProjectAndFieldTemplate). DynamoDB rejects a write when an index key
 * attribute is present with a type other than the key's type, and a NULL attribute counts as the wrong type; an absent
 * attribute is fine and simply keeps the item out of that index. A BatchPutItem containing one such item fails as a
 * whole, so a single LINK alt instance (which has no field template by design) sent as `fieldTemplateId: null` used to
 * drop its entire 25-item chunk.
 */
export const FIELD_INSTANCE_INDEX_KEYS = ["fieldTemplateId", "formInstance", "tableField", "projectId"];

/**
 * Returns a shallow copy of `item` without any of `keys` whose value is null. Other null attributes are kept.
 * @param item The document about to be sent to a batch resolver
 * @param keys The index key attribute names to check (defaults to FIELD_INSTANCE_INDEX_KEYS)
 */
export function stripNullIndexKeys<T extends Record<string, unknown>>(item: T, keys: string[] = FIELD_INSTANCE_INDEX_KEYS): T {
	const copy: Record<string, unknown> = { ...item };
	for (const key of keys) {
		if (key in copy && copy[key] === null) delete copy[key];
	}
	return copy as T;
}
